export default __webpack_public_path__ + "static/media/header-background.e0c19329.png";